import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "sonner";
import { Page } from "../../components/page";
import { Button } from "../../components/ui/button";
import { FieldError, Input, Label } from "../../components/ui/input";
import { authClient } from "../../lib/auth";
import { useMe } from "../../lib/hooks";

export const Route = createFileRoute("/_app/account")({ component: Account });

function Account() {
  const me = useMe();
  const [error, setError] = useState<string>();
  const [saving, setSaving] = useState(false);

  return (
    <Page title="Account" subtitle={me.user.email}>
      <form
        className="flex max-w-sm flex-col gap-4"
        onSubmit={async (e) => {
          e.preventDefault();
          const form = e.currentTarget;
          const data = new FormData(form);
          const currentPassword = String(data.get("currentPassword"));
          const newPassword = String(data.get("newPassword"));
          if (newPassword !== String(data.get("confirmPassword"))) {
            return setError("The new passwords don't match");
          }
          setError(undefined);
          setSaving(true);
          // Signs out all other sessions; this one stays signed in.
          const { error } = await authClient.changePassword({
            currentPassword,
            newPassword,
            revokeOtherSessions: true,
          });
          setSaving(false);
          if (error) return setError(error.message ?? "Could not change password");
          form.reset();
          toast.success("Password changed");
        }}
      >
        <h2 className="font-medium">Change password</h2>
        <div className="flex flex-col gap-2">
          <Label htmlFor="currentPassword">Current password</Label>
          <Input
            id="currentPassword"
            name="currentPassword"
            type="password"
            autoComplete="current-password"
            required
          />
        </div>
        <div className="flex flex-col gap-2">
          <Label htmlFor="newPassword">New password (min. 10 characters)</Label>
          <Input
            id="newPassword"
            name="newPassword"
            type="password"
            minLength={10}
            autoComplete="new-password"
            required
          />
        </div>
        <div className="flex flex-col gap-2">
          <Label htmlFor="confirmPassword">Repeat new password</Label>
          <Input
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            minLength={10}
            autoComplete="new-password"
            required
          />
        </div>
        <FieldError>{error}</FieldError>
        <Button type="submit" disabled={saving} className="self-start">
          Change password
        </Button>
      </form>
    </Page>
  );
}
